import React from 'react';
import { cn } from '../../utils/cn';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
  showText?: boolean;
  text?: string;
  color?: string;
}

const Loader: React.FC<LoaderProps> = ({
  size = 'medium',
  className,
  showText = false,
  text = 'Loading...',
  color = 'border-primary',
}) => {
  const sizeMap = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12',
  };

  const borderSizeMap = {
    small: 'border-2',
    medium: 'border-2',
    large: 'border-4',
  };

  return (
    <div className={cn('flex flex-col items-center justify-center', className)}>
      <div
        className={cn(
          'rounded-full border-solid animate-spin',
          sizeMap[size],
          borderSizeMap[size],
          color,
          'border-t-transparent'
        )}
      />
      {showText && (
        <p className="text-sm text-gray-600 font-medium mt-4">{text}</p>
      )}
    </div>
  );
};

export default Loader;
